import { render, staticRenderFns } from "./inputSector.vue?vue&type=template&id=b14135a6&scoped=true&"
import script from "./inputSector.vue?vue&type=script&lang=js&"
export * from "./inputSector.vue?vue&type=script&lang=js&"
import style0 from "./inputSector.vue?vue&type=style&index=0&id=b14135a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14135a6",
  null
  
)

export default component.exports